module.exports = __webpack_public_path__ + "static/media/gogig-onboarding-2.929ab37b.png";